import { TenantActions } from './actions';
import { GLOBAL_RESOURCES } from 'src/constants';
import { useInstanceEvaluations } from 'src/hooks';

/**
 * Shared by every consumer of a tenant's data (the page and its breadcrumb)
 * so they all gate on the exact same authorization check.
 */
export const useTenantAuthorization = (tenantId?: string) =>
  useInstanceEvaluations({
    actions: [...Object.values(TenantActions)],
    requiredActions: [TenantActions.READ],
    resource: { id: tenantId!, type: GLOBAL_RESOURCES.TM_TENANT },
  });
